import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
// librerias
import VueSweetalert2 from 'vue-sweetalert2'
import VueLoaders from 'vue-loaders'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-loaders/dist/vue-loaders.css'
// observador realtime
import moment from 'moment'
import { onValue, query, orderByChild, startAfter, endAt } from "firebase/database"
import { refTurnos } from './firebase'

Vue.config.productionTip = false

Vue.use(VueSweetalert2, {
  confirmButtonColor: '#4CAF50',
  cancelButtonColor: '#FF5252',
})
Vue.use(VueLoaders)

// crea el observador para los turnos
const fecha_inicio = + new Date(moment(new Date()).startOf('week'))
const fecha_fin = + new Date(moment(new Date()).endOf('week'))
const req = query(refTurnos, orderByChild('timestamp'), startAfter(fecha_inicio), endAt(fecha_fin))
onValue(req, (snapshot) => {
  const data = snapshot.val()
  store.dispatch('turnos_tv', data)
})

// obtiene la hora
function refreshTime () {
  var dateString = moment(new Date()).format('HH:mm:ss - DD/MM/YYYY')
  store.state.hora = dateString
}
setInterval(refreshTime, 1000)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
